import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ConstantCostsService } from '../../services/constant-costs.service';

@Component({
  selector: 'app-create-constant-costs',
  templateUrl: './create-constant-costs.component.html',
  styleUrls: ['./create-constant-costs.component.css']
})
export class CreateConstantCostsComponent implements OnInit {

  constantCostForm: FormGroup;

  constructor(
    private constantCostsService: ConstantCostsService,
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm(){
    this.constantCostForm = this.fb.group({
      folio: ['', Validators.required],
      description: ['', Validators.required],
      value: ['', Validators.required]
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    this.constantCostsService.addConstantCost(value);
  }

}
